import { render, staticRenderFns } from "./FormGroupBuilder.vue?vue&type=template&id=2e9ed986&"
import script from "./FormGroupBuilder.vue?vue&type=script&lang=js&"
export * from "./FormGroupBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports